import { useCallback } from 'react';

import { ROUTES } from '@/consts/routes';
import { selectClearAuth, useAuthStore } from '@/stores/useAuthStore';
import { useAuth as useClerkAuth } from '@clerk/react';

export const useAuth = () => {
  const clearAuth = useAuthStore(selectClearAuth);
  const { signOut } = useClerkAuth();

  const logout = useCallback(() => {
    void signOut({ redirectUrl: `${import.meta.env.VITE_BASE_URL}${ROUTES.auth.login}` }).then(() => {
      clearAuth();
    });
  }, [clearAuth, signOut]);

  return {
    logout
  };
};
